import script from "./RimWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./RimWidget.vue?vue&type=script&setup=true&lang=js"

import "./RimWidget.vue?vue&type=style&index=0&id=74cf0548&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74cf0548"]])

export default __exports__